<template>
  <section class="wrapper">
  <div class="backlinks-tool">
      <header class="header">
        <h1 class="title">Backlinks tool – share your thoughts before we build it</h1>
        <p class="subtitle">
          We're building a new tool to help you secure high-quality<br>
          backlinks effortlessly with POP. Here's what's included:
        </p>
      </header>

      <div class="features-grid">
        <div class="feature-card">
          <img src="../assets/svgs/Link_insertions.svg" alt="link insertions Icon">
          <div class="feature-content">
            <h3 class="feature-title">Link insertions</h3>
            <p class="feature-description">
              Purchase a backlink by placing your link in existing content on authoritative websites
            </p>
          </div>
        </div>

        <div class="feature-card">
          <img src="../assets/svgs/AI_powered_guest.svg" alt="AI-powered guest posts Icon">
          <div class="feature-content">
            <h3 class="feature-title">AI-powered guest posts</h3>
            <p class="feature-description">
              POP AI writes a guest post with optimized anchor text, ready for paid placement on quality sites
            </p>
          </div>
        </div>
      </div>
  </div>
  <div class="backlinks-tool">
    <BacklinksMockupCarousel />
  </div>
  </section>
</template>

<script>
import BacklinksMockupCarousel from '@/common/BacklinksMockupCarousel/BacklinksMockupCarousel.vue';

export default {
  name: 'ShareFeedback',
  components: {
    BacklinksMockupCarousel
  },
}
</script>

<style lang="scss" scoped>
.wrapper{
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
  background-color: #f9f9f9;

  .backlinks-tool {
    padding: 60px 20px;
    background-color: #ffffff;
    border: 0.5px solid #CCCCCC;
    border-radius: 5px;
  
    .header {
      display: flex;
      flex-direction: column;
      gap: 10px;
      text-align: center;
      margin-bottom: 60px;
  
      .title {
        font-family: Mulish;
        font-weight: 700;
        font-style: Bold;
        font-size: 26px !important;
        line-height: 100%;
        text-align: center;
        color: #000000;

        @media (max-width: 768px) {
          font-size: 1rem;
        }
      }

     .subtitle {
      font-family: 'Mulish', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 17px;
      line-height: 140%;
      text-align: center;
      color: #000000;
    }

    }

    .features-grid {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 24px;
      }
    }

    .feature-card {
      max-width: 357px;
      min-height: 140px;
      border-radius: 10px;
      border: 0.5px solid #CCCCCC;
      display: flex;
      align-items: start;
      gap: 16px;
      padding: 20px 20px 12px 20px;

      img{
        width: 60px;
        height: 60px;
      }

      .feature-content {
        display: flex;
        flex-direction: column;
        gap: 8px;
       .feature-title {
        font-family: 'Mulish', sans-serif;
        font-weight: 700;
        font-style: normal;
        font-size: 17px;
        line-height: 21px; /* 100% of font-size */
        text-align: left; /* optional, based on layout */
        color: #000000;
      }


        .feature-description {
        font-family: 'Mulish', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 15px;
        line-height: 140%; /* 21px */
        color: #000000;
      }

      }
    }

    // Responsive adjustments
    @media (max-width: 768px) {
      padding: 40px 20px;
      .header {
        margin-bottom: 40px;
        .title {
          font-size: 1.75rem;
        }
        .subtitle {
          font-size: 1rem;
        }
      }
      .feature-card {
        padding: 24px;
      }
    }
  }
}
</style>